export const ZINDEX = {
  MODAL: 900001,
  TABLE_SHADOW: 900001,
  POPOVER: 900002,
  TOOLTIP: 900002,
  TOAST: 900003,
};

export const ACTIVE_INPUT_OPACITY = 0.4;
